// All app preference keys
const PreferenceKeys = {
  // api key
  apiKey: 'admin_apiKey',
  // login info
  savedLoginEmail: 'admin_saved_login_email',
  savedLoginPassword: 'admin_saved_login_password',
  savedLoginAccount: 'admin_saved_login_account',
};

export default PreferenceKeys;
